/**
 * patch jQuery with select2 functions
 * @note maybe create select2 components with specific markup
 * and initializers instead of global patch.
 *
 * Because JavaScript... https://github.com/select2/select2/issues/6081#issuecomment-1570972248
 * and this might not even be enough to get it working outside development
 */
import jQuery from 'jquery';

import './select2.scss';
import select2 from '@vendor/javascripts/select2';

select2(jQuery);
